import * as React from 'react';
import { ListItemIcon, MenuItem, MenuList } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CustomMenu() {
  // 다국어
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleEditUserInfo = React.useCallback(() => {
    navigate('/my-page'); // 'edit-user-info' 경로로 이동
  }, []);

  return (
    <MenuList dense disablePadding>
      {/* 회원정보 관리 */}
      <MenuItem
        onClick={handleEditUserInfo}
        component="button"
        sx={{
          justifyContent: 'flex-start',
          width: '100%'
        }}
      >
        <ListItemIcon>
          <SettingsIcon />
        </ListItemIcon>
        {t('edit_user_info_title')}
      </MenuItem>
    </MenuList>
  );
}
